import { CmsComponent, Converter } from '@spartacus/core'
import { Injectable, InjectionToken } from '@angular/core'
import { BooleanInput, ConvertedComponentData, LinkData, TextInput } from '../../../types'
import { CmsConverterService, defaultLinkData, defaultTextInput } from '../../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class AccordionMainContentLinkConverter extends CmsConverterService<AccordionMainContentLinkData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      text: formData.st_accordion_link_headline ?? defaultTextInput,
      link: formData.st_input_link ?? defaultLinkData,
      inverted: formData.st_inverted?.value ?? false,
    }
  }
}

export const ACCORDION_MAIN_CONTENT_LINK_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, AccordionMainContentLinkData>>('AccordionMainContentLinkConverter')

export interface AccordionMainContentLinkData extends ConvertedComponentData {
  link: LinkData;
  inverted: BooleanInput;
  text: TextInput;
}
